import { inject, Injectable } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { NotificationComponent } from '../../components/notification/notification.component';
import { SnackbarComponent } from '../../components/snackbar/snackbar.component';
import { INotification, ISnackbarData } from '../../models/notification';

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  private snackBar: MatSnackBar = inject(MatSnackBar)
  // Example method to show a notification popup
  showNotification(notificationData: INotification): void {
    this.snackBar.openFromComponent(NotificationComponent, {
      data: notificationData, // Customize the message here
      duration: 5000, // Snackbar duration in ms
      panelClass: 'custom-snackbar-container', // Optional custom class for further styling
      horizontalPosition: 'center',
      verticalPosition: 'top'
    });
  }

  showSnackBar(snackBarData: ISnackbarData): void {
    this.snackBar.openFromComponent(SnackbarComponent, {
      data: snackBarData, // Customize the message here
      duration: snackBarData.duration ?? this.calculateDuration(snackBarData.message),
      panelClass: 'custom-snackbar-container', // Optional custom class for further styling
      horizontalPosition: 'center',
      verticalPosition: 'bottom'
    });
  }

  private calculateDuration(message: string): number {
    // Base duration in milliseconds
    const baseDuration = 2000;

    // Words per minute (average reading speed)
    const wpm = 200;

    // Calculate reading time in milliseconds
    // Assuming average word length of 5 characters + 1 space
    const words = message.length / 6;
    const readingTimeMs = (words / wpm) * 60 * 1000;

    // Add base duration to reading time with min and max thresholds
    return Math.max(2000, Math.min(8000, baseDuration + readingTimeMs));
  }
}
